
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2024-08-11-react-three-fiber-6-environment",
      function () {
        return require("private-next-pages/blogs/2024-08-11-react-three-fiber-6-environment/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2024-08-11-react-three-fiber-6-environment"])
      });
    }
  